<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Ürün Bilgileri
        </template>
        <b-form-group
          label="Başlık"
          label-for="title"
        >
          <b-form-input
            id="title"
            v-model="itemData.translate.title"
            placeholder="Başlık"
          />
          <b-alert show>
            <div class="alert-body mt-1 font-small-2">
              {{ itemData.item.title }}
            </div>
          </b-alert>
        </b-form-group>
        <b-form-group
          label="Özet Metin"
          label-for="summary"
        >
          <b-form-textarea
            id="summary"
            v-model="itemData.translate.summary"
            placeholder="Özet Metin"
          />
          <b-alert show>
            <div class="alert-body mt-1 font-small-2">
              <div v-html="itemData.item.summary" />
            </div>
          </b-alert>
        </b-form-group>
        <b-form-group
          label="İçerik"
          label-for="content"
        >
          <quill-editor
            id="content"
            v-model="itemData.translate.content"
            class="bg-white"
            :options="editorOption"
          >
            <div
              id="content_toolbar"
              slot="toolbar"
            >
              <editor-toolbar />
            </div>
          </quill-editor>
          <b-alert show>
            <div class="alert-body mt-1 font-small-2">
              <div v-html="itemData.item.content" />
            </div>
          </b-alert>
        </b-form-group>
        <b-form-group
          label="Avantajlar"
          label-for="technical_content"
        >
          <quill-editor
            id="technical_content"
            v-model="itemData.translate.extras"
            class="bg-white"
            :options="tcEditorOption"
          >
            <div
              id="technical_content_toolbar"
              slot="toolbar"
            >
              <editor-toolbar />
            </div>
          </quill-editor>
          <b-alert show>
            <div class="alert-body mt-1 font-small-2">
              <div v-html="itemData.item.extras" />
            </div>
          </b-alert>
        </b-form-group>
        <b-form-group
          label="Teknik Özellikler Notu"
          label-for="notes"
        >
          <b-form-textarea
            id="notes"
            v-model="itemData.translate.notes"
            placeholder="Teknik Özellikler Notu"
          />
          <b-alert show>
            <div class="alert-body mt-1 font-small-2">
              <div v-html="itemData.item.notes" />
            </div>
          </b-alert>
        </b-form-group>
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Ürün Teknik Özellikleri
        </template>
        <template v-for="(row,index) in itemData.item.items">
          <b-row :key="index">
            <b-col
              cols="6"
            >
              <b-form-group
                label="Başlık"
                :label-for="'title_' + index"
              >
                <b-form-input
                  v-model="row.translate.content.title"
                  placeholder="Giriniz"
                />
              </b-form-group>
              <b-alert show>
                <div class="alert-body mt-1 font-small-2">
                  <div v-html="row.title" />
                </div>
              </b-alert>
            </b-col>
            <b-col
              cols="6"
            >
              <b-form-group
                label="Değer & Açıklama"
                :label-for="'value_' + index"
              >
                <b-form-input
                  v-model="row.translate.content.value"
                  placeholder="Giriniz"
                />
              </b-form-group>
              <b-alert show>
                <div class="alert-body mt-1 font-small-2">
                  <div v-html="row.value" />
                </div>
              </b-alert>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
          </b-row>
        </template>
      </b-tab>
    </b-tabs>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BFormTextarea, BAlert, BButton, BTabs, BTab, BRow, BCol,
} from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'

export default {
  name: 'Contents',
  components: {
    EditorToolbar,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BAlert,
    BButton,
    quillEditor,
    BTabs,
    BTab,
    BRow,
    BCol,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: '#content_toolbar',
        },
        theme: 'snow',
      },
      tcEditorOption: {
        modules: {
          toolbar: '#technical_content_toolbar',
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
